import { createDucks } from '@8powers/core/redux';

const { reducer, saga, actions } = createDucks('protocol', {
  protocol: {
    endpoint: 'protocol',
    slices: ['list', 'detail', 'create', 'edit']
  },
  contract: {
    endpoint: 'contract',
    slices: ['combo']
  },
  company: {
    endpoint: 'company',
    slices: ['combo']
  },
  cost: {
    endpoint: 'cost',
    slices: ['create']
  }
});

export { saga, actions };
export default reducer;
